import { ref } from "vue";
import useSupabase from '../lib/supabaseClient'
import { useUserStore } from "../store/user";
import router from "@/router";

const { supabase } = useSupabase();
// user is set outside of the useAuthUser function
// so that it will act as global state and always refer to a single user
const user = ref(null);

export default function useAuthUser() {
  /**
   * Login with email and password
   */

const signUp = async ({ email, password,meta }) => {
  const { data, error } = await supabase.auth.signUp({ email, password, options: { data:meta } });
  console.log(data, error);
  if (error) throw error;
  alert(error);
  return user;
};



  const loginWithEmail = async ({ email, password }) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    console.log(user, error);
    
    if (error) throw error;
    return user;
  };

  /**
   * Login with google, github, etc
   */
  const loginWithSocialProvider = async (provider) => {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: provider, options: {
        scopes: 'email profile https://www.googleapis.com/auth/userinfo.profile openid https://www.googleapis.com/auth/spreadsheets.readonly https://www.googleapis.com/auth/userinfo.email',

        queryParams: {
          hd: "whirlpool.com",
          prompt: 'consent'

        }
      }
    });
    console.log("USER DATA",(data));
    
    
    if (error) throw error;
    return data;
  };
  /**
   * Logout
   */
  const logout = async () => { };

  /**
   * Check if the user is logged in or not
   */
  const isLoggedIn = () => { };

  /**
   * Register
   */
  const register = async ({ email, password, ...meta }) => { };

  /**
   * Update user email, password, or meta data
   */
  const update = async (data) => { };

  /**
   * Send user an email to reset their password
   * (ie. support "Forgot Password?")
   */
  const sendPasswordRestEmail = async (email) => { };

  return {
    user,
    signUp,
    loginWithEmail,
    loginWithSocialProvider,
    isLoggedIn,
    logout,
    register,
    update,
    sendPasswordRestEmail,
    // maybeHandleEmailConfirmation,
  };
}